import { useTranslation } from "react-i18next";
import { PreferenceLine } from "../../preferenceLine";

interface BillingEntityGroupProps {
  companyName: string;
  street: string;
  postalCode: string;
  city: string;
  country: string;
  numberTVA?: string;
  companySiret: string;
  companyEori: string;
  email: string;
  emailBis: string;
  paymentMethod: string;
}

export const BillingEntityGroup = ({
  companyName,
  street,
  postalCode,
  city,
  numberTVA,
  companySiret,
  companyEori,
  email,
  emailBis,
}: BillingEntityGroupProps) => {
  const { t } = useTranslation("boClients");
  return (
    <div className="flex flex-col gap-0">
      <PreferenceLine
        title={t("profileBillingEntityGroup.companyNameLabel")}
        value={[companyName]}
      />
      <PreferenceLine
        title={t("profileBillingEntityGroup.billingAddressLabel")}
        value={[
          t("profileBillingEntityGroup.billingAddressStreet", { street }),
          t("profileBillingEntityGroup.billingAddressCity", { postalCode, city }),
        ]}
      />
      <PreferenceLine title={t("profileBillingEntityGroup.billingEmailLabel")} value={[email]} />
      {emailBis && (
        <PreferenceLine
          title={t("profileBillingEntityGroup.billingEmailBisLabel")}
          value={[emailBis]}
        />
      )}
      <PreferenceLine
        title={t("profileBillingEntityGroup.vatNumberLabel")}
        value={[numberTVA || t("profileBillingEntityGroup.undefinedValue")]}
      />
      <PreferenceLine title={t("profileBillingEntityGroup.siretLabel")} value={[companySiret]} />
      <PreferenceLine
        title={t("profileBillingEntityGroup.eoriLabel")}
        value={[companyEori || t("profileBillingEntityGroup.undefinedValue")]}
      />
    </div>
  );
};
